(function($) {

  $(document).ready(function(){

    // mobile menu
    $('.header__toggle').click(function(){
      $(this).toggleClass('open');
      $('.mobile-menu').slideToggle();
    });

    // homepage slider
    $('.homepage__slides').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      dots: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear'
    });

    // attorney sidebar accordion
    $('.attorney__body-stat h2').click(function(){
      if(!$(this).hasClass('active')) {
        $('.attorney__body-stat-text').slideUp();
        $('.attorney__body-stat h2').removeClass('active');
        $(this).addClass('active');
        $(this).next('div').slideDown();
      } else {
        $(this).removeClass('active');
        $(this).next('div').slideUp();
      }
    });
  });

})(jQuery);
